import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/utils/api";

// Async thunks
export const fetchSubmissions = createAsyncThunk(
  "submissions/fetchSubmissions",
  async (district_id, { rejectWithValue }) => {
    try {
      const response = await api.get(`/district_wise_applications`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchSubmission = createAsyncThunk(
  "submissions/fetchSubmission",
  async (submissionId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/submissions/${submissionId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateSubmission = createAsyncThunk(
  "submissions/updateSubmission",
  async ({ submissionId, data }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `/submissions/${submissionId}/status`,
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const assignSubmission = createAsyncThunk(
  "submissions/assignSubmission",
  async ({ submissionId, visitorId }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/submissions/${submissionId}/assign`, {
        visitor_id: visitorId,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const submissionSlice = createSlice({
  name: "submissions",
  initialState: {
    submissions: [],
    currentSubmission: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubmissions.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSubmissions.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload || {};
        const list = [];

        const map = {
          modernization_forms: "Modernization",
          new_shuttleless: "New Shuttleless",
          cfc_subsidy: "CFC Subsidy",
        };

        const typeMap = {
          modernization_forms: "modernization",
          new_shuttleless: "new_shuttleless",
          cfc_subsidy: "cfc_subsidies",
        };

        Object.keys(map).forEach((key) => {
          const items = payload[key];
          if (Array.isArray(items)) {
            items.forEach((it) => {
              list.push({
                ...it,
                form: { name: map[key] },
                type: typeMap[key],  
                applicant: { name: it.applicant_name },
                application_no: it.application_no,
                district: { name: it.district?.name || "" },
                status: it.status === "pending" ? "submitted" : it.status,
              });
            });
          }
        });

        state.submissions = list;
      })
      .addCase(fetchSubmissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch submissions";
      })
      .addCase(fetchSubmission.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSubmission.fulfilled, (state, action) => {
        state.loading = false;
        state.currentSubmission = action.payload;
      })
      .addCase(fetchSubmission.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch submission";
      })
      .addCase(updateSubmission.fulfilled, (state, action) => {
        const index = state.submissions.findIndex(
          (s) => s.id === action.payload.id
        );
        if (index !== -1) {
          state.submissions[index] = action.payload;
        }
        if (
          state.currentSubmission &&
          state.currentSubmission.id === action.payload.id
        ) {
          state.currentSubmission = action.payload;
        }
      });
  },
});

export const { clearError } = submissionSlice.actions;
export default submissionSlice.reducer;
